/* ============================================================================
   STİL KOMBİNİ — ÜRÜN DETAY sayfası davranışları.
   Hero'nun hotspot + toplu sepete ekleme mantığı koleksiyon modülünden
   (window.TCLookbook) yeniden kullanılır — kopyalama yok.
   Beğeni ve anket: Faz 1 = localStorage (dürüst, sunucuya yazmaz);
   Faz 2 kancaları sendLike()/sendVote() içinde TODO olarak bırakıldı.
   ========================================================================== */
(function () {
  if (window.__tcLookbookProduct) return;
  window.__tcLookbookProduct = 1;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // 1) HERO: koleksiyon modülünü yeniden kullan (hotspot ↔ liste + /cart/add.js toplu)
    if (window.TCLookbook && typeof window.TCLookbook.initCard === 'function') {
      document.querySelectorAll('.slp-hero[data-look]').forEach(window.TCLookbook.initCard);
    }
    initGallery();
    initSticky();
    initLikes();
    initSurveys();
    initShare();
    sortSimilar();
    initHotspotEditor();
  });

  /* --- HOTSPOT DÜZENLEME MODU (?hotspots=edit) ---
     Noktaları sürükle-bırakla konumlandır; panel canlı JSON üretir.
     Yalnızca görsel/yerel bir araçtır — sunucuya YAZMAZ; üretilen JSON
     admin > ürün > Metafields > Hotspots alanına yapıştırılır. --- */
  function initHotspotEditor() {
    if (!/[?&]hotspots=edit/.test(window.location.search)) return;
    var hero = document.querySelector('.slp-hero[data-look]');
    if (!hero) return;
    var media = hero.querySelector('.slp-hero-media');
    var dots = media ? media.querySelectorAll('.tc-lb-dot') : [];
    if (!media || !dots.length) return;
    media.classList.add('is-hotspot-edit');

    var handleByIdx = {};
    hero.querySelectorAll('.tc-lb-row').forEach(function (r) {
      handleByIdx[r.getAttribute('data-idx')] = r.getAttribute('data-handle');
    });

    var panel = document.createElement('div');
    panel.className = 'slp-hsedit';
    panel.innerHTML =
      '<b>Hotspot Düzenleme Modu</b>' +
      '<p>Görseldeki numaralı noktaları sürükleyip ürünlerin üzerine bırakın. ' +
      "Sonra JSON'u kopyalayıp admin → ürün → Metafields → <b>Hotspots</b> alanına yapıştırın.</p>" +
      '<textarea readonly rows="4" spellcheck="false"></textarea>' +
      '<button type="button" data-copy>JSON&#39;u Kopyala</button>';
    document.body.appendChild(panel);
    var ta = panel.querySelector('textarea');
    var btn = panel.querySelector('[data-copy]');

    function serialize() {
      var arr = [];
      dots.forEach(function (d) {
        var idx = d.getAttribute('data-idx');
        arr.push({
          handle: handleByIdx[idx] || ('urun-' + idx),
          x: Math.round(parseFloat(d.style.left) * 10) / 10,
          y: Math.round(parseFloat(d.style.top) * 10) / 10
        });
      });
      ta.value = JSON.stringify(arr);
    }
    serialize();

    dots.forEach(function (d) {
      d.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        try { d.setPointerCapture(e.pointerId); } catch (err) {}
        function move(ev) {
          var r = media.getBoundingClientRect();
          var x = Math.min(98, Math.max(2, ((ev.clientX - r.left) / r.width) * 100));
          var y = Math.min(98, Math.max(2, ((ev.clientY - r.top) / r.height) * 100));
          d.style.left = x + '%';
          d.style.top = y + '%';
          serialize();
        }
        function up() {
          d.removeEventListener('pointermove', move);
          d.removeEventListener('pointerup', up);
        }
        d.addEventListener('pointermove', move);
        d.addEventListener('pointerup', up);
      });
    });

    btn.addEventListener('click', function () {
      ta.select();
      var done = function () {
        btn.textContent = 'Kopyalandı ✓';
        setTimeout(function () { btn.textContent = "JSON'u Kopyala"; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(ta.value).then(done).catch(function () { document.execCommand('copy'); done(); });
      } else {
        document.execCommand('copy');
        done();
      }
    });
  }

  /* --- GALERİ: küçük görsele tıklayınca ana görseli değiştir.
         Hotspotlar yalnızca 1. (ana) görselde geçerli → diğerlerinde gizlenir. --- */
  function initGallery() {
    document.querySelectorAll('.slp-gallery[data-gallery]').forEach(function (gal) {
      var hero = gal.closest('.slp-hero');
      if (!hero) return;
      var main = hero.querySelector('.slp-hero-img');
      var media = hero.querySelector('.slp-hero-media');
      if (!main) return;
      var thumbs = gal.querySelectorAll('.slp-gal-thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          if (!src) return;
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
          thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          if (media) media.classList.toggle('is-alt-view', t.getAttribute('data-first') !== 'true');
        });
      });
    });
  }

  /* --- MOBİL YAPIŞKAN SATIN ALMA ÇUBUĞU: hero'daki satın alma alanı
         ekranın üstünden çıkınca görünür; buton hero'daki gerçek butona vekildir. --- */
  function initSticky() {
    document.querySelectorAll('.slp-sticky[data-sticky]').forEach(function (bar) {
      var hero = bar.closest('.slp-hero');
      if (!hero) return;
      var buy = hero.querySelector('[data-buy]');
      var addBtn = hero.querySelector('.tc-lb-add');
      var proxy = bar.querySelector('[data-sticky-add]');
      if (proxy && addBtn) {
        proxy.addEventListener('click', function () {
          addBtn.click();
          // beden seçilmemişse ilgili satırı görünür yap
          setTimeout(function () {
            var miss = hero.querySelector('.tc-lb-row.needs-variant');
            if (miss && miss.scrollIntoView) miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 60);
        });
      }
      if (!buy || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(buy);
    });
  }

  /* --- BEĞENİ (Faz 1: localStorage optimistic; tek kullanıcı bir kez) --- */
  function initLikes() {
    document.querySelectorAll('.slp-like[data-like]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product');
      var key = 'tclq_like_' + pid;
      var base = parseInt(btn.getAttribute('data-count'), 10) || 0;
      var liked = localStorage.getItem(key) === '1';
      var countEl = btn.querySelector('.slp-like-count');
      function render() {
        btn.classList.toggle('is-liked', liked);
        btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
        if (countEl) countEl.textContent = base + (liked ? 1 : 0);
      }
      render();
      btn.addEventListener('click', function () {
        liked = !liked;
        if (liked) localStorage.setItem(key, '1'); else localStorage.removeItem(key);
        render();
        sendLike(pid, liked);
      });
    });
  }
  // Faz 2 kancası: kalıcı beğeni için app proxy veya ücretsiz wishlist/like uygulaması gerekir.
  function sendLike(productId, liked) {
    // TODO(Faz 2): fetch('/apps/tclq/like', { method:'POST',
    //   headers:{'Content-Type':'application/json'},
    //   body: JSON.stringify({ product: productId, liked: liked }) });
    // Faz 1'de sunucuya yazım YOK — yalnızca localStorage.
  }

  /* --- MİNİ ANKET (Faz 1: localStorage tek oy, yüzdeleri aç) --- */
  function initSurveys() {
    document.querySelectorAll('.slp-survey[data-survey]').forEach(function (box) {
      var pid = box.getAttribute('data-product');
      var key = 'tclq_vote_' + pid;
      var opts = box.querySelectorAll('.slp-survey-opt');
      function reveal(pickedIdx) {
        box.classList.add('is-voted');
        opts.forEach(function (o) {
          var pct = parseInt(o.getAttribute('data-pct'), 10) || 0;
          var fill = o.querySelector('.slp-opt-fill');
          if (fill) fill.style.width = pct + '%';
          o.classList.toggle('is-picked', String(o.getAttribute('data-opt')) === String(pickedIdx));
        });
      }
      var voted = localStorage.getItem(key);
      if (voted !== null) reveal(voted);
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          if (box.classList.contains('is-voted')) return;
          var idx = o.getAttribute('data-opt');
          localStorage.setItem(key, idx);
          reveal(idx);
          sendVote(pid, idx);
        });
      });
    });
  }
  function sendVote(productId, optionIdx) {
    // TODO(Faz 2): app proxy endpoint'ine oy yaz. Faz 1: yalnızca localStorage.
  }

  /* --- PAYLAŞIM: Instagram (Web Share API varsa; yoksa bağlantı kopyala) --- */
  function initShare() {
    document.querySelectorAll('.slp-share-ig[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url'), title = btn.getAttribute('data-title') || '';
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            toast(btn.getAttribute('data-copied') || 'Bağlantı kopyalandı');
          }).catch(function () { window.prompt('', url); });
        } else {
          window.prompt('', url);
        }
      });
    });
  }

  /* --- BENZER KOMBİNLER: beğeni sayısına göre azalan sırala --- */
  function sortSimilar() {
    document.querySelectorAll('.slp-similar[data-similar]').forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.slp-sim-card'));
      cards.sort(function (a, b) {
        return (parseInt(b.getAttribute('data-likes'), 10) || 0) - (parseInt(a.getAttribute('data-likes'), 10) || 0);
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* --- küçük bildirim --- */
  function toast(msg) {
    var t = document.getElementById('slp-toast');
    if (!t) { t = document.createElement('div'); t.id = 'slp-toast'; t.className = 'slp-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__slpT);
    window.__slpT = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
})();
